<template>
  <div class="addressfoot">
    <div class="row flex-row-reverse justify-content-between align-item-center">
      <div class="text-center" :class="out_stock ? 'out_stock' : 'col-md-5 col-lg-6'">
        <button
          class="checkout_btn_color"
          :class="{ button_active: active, nothing: nothing }"
          :style="{ filter: active ? 'opacity(60%)' : '' }"
          @click="!active && !nothing && toNextApi && toNextApi()"
          :id="checkoutBtnId || ''"
        >
          {{ toNext }}
        </button>
      </div>
      <div class="col-md-6 text-md-left text-center align-item-center">
        <a class="checkout_accent_color r_inf" :href="href" v-html="hint" @click="checkoutArrive"></a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['toNext', 'toPrev', 'toshipping', 'nothing', 'out_stock', 'checkoutBtnId', 'toNextApi'],
  data() {
    return {
      active: false,
      href: '',
      hint: '',
      tip: '',
    }
  },
  // methods: {
  //   toNextApi() {
  //     this.$emit('toNextApi')
  //   },
  // },
  beforeMount() {
    switch (this.toPrev) {
      case 'cart':
        this.href = '/cart'
        this.tip = this.$t('shopping.return_cart')
        break
      case 'contact_information':
        this.href = this.replaceSearch('step', 'contact_information')
        this.tip = this.$t('shopping.return_information')
        break
      case 'shipping_method':
        this.href = this.replaceSearch('step', 'shipping_method')
        this.tip = this.$t('shopping.return_shipping')
        break
      default:
        this.href = this.replaceSearch('step', 'contact_information')
        this.tip = this.$t('shopping.return_information')
        break
    }
    this.hint = this.tip
  },
  methods: {
    checkoutArrive(event) {
      switch (this.toPrev) {
        case 'contact_information':
          //返回information 提交物流信息
          event.preventDefault()
          this.$store.dispatch('change_checkout_arrive', 'contact_information')
          break
        case 'shipping_method':
          //返回shipping_method直接切换页面
          event.preventDefault()
          this.$store.commit('saveBaseState', { checkoutStep: 'shipping_method' })
          window.history.replaceState({}, '', this.replaceSearch('step', 'shipping_method', true))
          break
        default:
          break
      }
    },
  },
}
</script>
<style scoped lang='scss'>
.addressfoot {
  margin-top: 15px;
  button {
    font-size: 14px;
    padding: 20px 24px;
    width: 100%;
    border: none;
    background: #0f88a7;
    color: #f7f7f7;
    font-weight: bold;
    border-radius: 5px;

    span {
      word-break: break-all;
    }
  }
  button:hover {
    filter: opacity(80%);
  }

  .nothing {
    background-color: #cccc !important;
    color: #fff !important;
    cursor: default;
  }

  a {
    height: 61px;
    line-height: 61px;
    text-decoration: none;
    color: #0f88a7;
    font-size: 14px;
  }
  .r_inf::before {
    content: '\e691';
    font-family: 'iconfont';
    font-weight: 600;
  }
}
@media screen and (max-width: 750px) {
  .out_stock {
    width: 100% !important;
  }
}
</style>
